import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { API_SERVER, initializeFilterData } from '../../Utils';
import { useAuth } from '../../context/auth';
import { AutoCompleteBox, DateBox, FormButton, TimeBox } from "../commoncomponents/InputBox";
//services
import { useNavigate } from 'react-router-dom';
import { getCommonData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service';
import { Token, dateFormate } from '../Common/Common';

function AttendanceRequisition() {
    const TokenData = Token();
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    const navigate = useNavigate();

    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false);

    const [OUTTime, setOUTTime] = useState({});
    const [INTime, setINTime] = useState({});
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [isUpdate, setIsUpdate] = useState(false)
    const [employeeAllData, setEmployeeAllData] = useState([])
    const [errors, setErrors] = useState({});
    const [ShowError, setShowError] = useState(false);

    const [recipe, setRecipe] = useState({
        Employee: '',
        Date: '',
        INTime: '',
        OUTTime: '',
        Remarks: ''
    })

    const EmployeeAllData = (value) => {
        setEmployeeAllData([])
        let temp = {
            Type: "GetEmployee",
            Prefix: value ? value : "",
            ContextKey: '',
            ContextKey2: ""
        }
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setEmployeeAllData(data)
                }
            }
        });
    }

    //Change Handler
    const HandleChange = (prop, value) => {
        if (prop === 'INTime') {
            setINTime(value)
        } else if (prop === 'OUTTime') {
            setOUTTime(value)
        } 
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const Validate = () => {
        setErrors({})
        if (recipe.Remarks === '') {
            setShowError(true)
        }
        let isValid = true;
        let validation = [
            { field: "Employee", msg: 'Please Enter Employee.' },
            { field: "Date", msg: "Please Select Date." },
            { field: "INTime", msg: "Please Enter IN Time." },
            { field: "OUTTime", msg: 'Please Enter OUT Time.' },
        ];
        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {
                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });
        return isValid;
    }

    //Submit Handler
    const handleSubmit = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Employee/InsertAttendanceRequisition`, { ...TokenData, ...recipe }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        setLoading(false)
                    } else if (res.status === "EXPIRED") {
                        toast.error(res.message)
                        sessionExpired()
                    } else if (res.status === "UNAUTHORIZED") {
                        toast.error(res.message);
                        setLoading(false);
                    } else {
                        setLoading(false)
                        toast.success(res.message)
                        handleClear()
                    }
                }
            });
        }
    }

    //GetAttendanceRequisition
    const GetAttendanceRequisition = (Employee,Date) => {
        setLoading(true)
        post(`${API_SERVER}api/Employee/GetAttendanceRequisition`, {
            ...TokenData, Date: Date, Employee:Employee
        }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setRecipe(recipe => ({
                        ...recipe,
                        INTime:'',
                        OUTTime: '',
                    }))
                    setLoading(false)
                } else if (res.status === "EXPIRED") {
                    toast.error(res.message)
                    sessionExpired()
                } else if (res.status === "UNAUTHORIZED") {
                    toast.error(res.message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    let data = res.data
                    setRecipe(recipe => ({
                        ...recipe, 
                        INTime: data.inTime,
                        OUTTime: data.outTime,
                    }))
                    setShowError(false)
                }
            }
        });
    }


    //Reset Handler
    const handleClear = () => {
        setShowError(false);
        setRecipe(recipe => ({
            ...recipe,           
            Employee: '',
            Remarks: '',
            INTime:'',
            OUTTime: '',
            Date: '',
        }))
        setErrors({})
    }

    let EmployeeData = []
    for (let i = 0; i < employeeAllData.length; i++) {
        let mydata = employeeAllData[i]?.values
        EmployeeData.push(mydata)
    };

    useEffect(() => {
        inputrefs.current['txtEmployee'].focus()
        document.title = 'Viva HRMS : Attendance Regularisation'
        EmployeeAllData()
    }, [sortConfig, isUpdate])

    return (
        <>
            <div className='main-card card border-0 '>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> Attendance Regularisation</h6>
                </div>
                <div className='card-body'>
                    <div className='row ps-3 pt-2'>

                        <div className='row'>
                            <AutoCompleteBox
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtDate'].focus() };
                                }}
                                label='Employee'
                                placeholder="Employee"
                                maxLength='100'
                                options={EmployeeData}
                                id='txtEmployee'
                                key='txtEmployee'
                                required={true} error={errors.Employee}
                                inputValue={recipe.Employee ? recipe.Employee : ''}
                                onInputChange={(event, newInputValue) => {
                                    HandleChange('Employee', newInputValue)
                                    EmployeeAllData(newInputValue)
                                }}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        GetAttendanceRequisition(recipe.Employee, recipe.Date)
                                    };
                                }}
                                label='Date'
                                id='txtDate'
                                key='txtDate'
                                selected={recipe.Date === '' ? "" : new Date(recipe.Date)}
                                placeholder="Date"
                                error={errors.Date}
                                onChange={(e) => {
                                    HandleChange('Date', dateFormate(e))
                                    if (recipe.Date!=='') {
                                        GetAttendanceRequisition(recipe.Employee, recipe.Date)
                                    }
                                }}
                                onSelect={(e) => {
                                    HandleChange('Date', dateFormate(e))
                                    if (recipe.Date !== '') {
                                        GetAttendanceRequisition(recipe.Employee, recipe.Date)
                                    }
                                }}
                                required
                            />
                            <TimeBox
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtOUTTime'].focus() };
                                }}
                                divclassname='col-md-2 mb-1'
                                label='IN Time'
                                id='txtINTime'
                                key='txtINTime'
                                maxLength='7'
                                placeholder="IN Time"
                                selected={INTime}
                                value={recipe.INTime} error={errors.INTime}
                                onChange={(e) => { HandleChange('INTime', (e.target.value)) }}
                                required
                            />
                            <TimeBox
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtRemarks'].focus() };
                                }}
                                divclassname='col-md-2 mb-1'
                                label='OUT Time'
                                id='txtOUTTime'
                                key='txtOUTTime'
                                maxLength='7'
                                placeholder="OUT Time"
                                selected={OUTTime}
                                value={recipe.OUTTime} error={errors.OUTTime}
                                onChange={(e) => { HandleChange('OUTTime', (e.target.value)) }}
                                required
                            />
                            <div className='col-sm-12 col-md-3'>
                                <label>Remarks<span style={{ color: 'red' }}> *</span>
                                </label>
                                <textarea
                                className='form-control '
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { handleSubmit() };
                                }}
                                label='Remarks'
                                id='txtRemarks'
                                key='txtRemarks'
                                maxLength='500'
                                placeholder="Remarks"
                                value={recipe.Remarks} error={errors.Remarks}
                                    onChange={(e) => {
                                        HandleChange('Remarks', (e.target.value))
                                        setShowError(false)
                                    }}
                                    required
                                />
                                {(ShowError === true) ? <span style={{ color: 'tomato',fontSize:'10px' }}>Please Enter remarks.!</span> : <></>}
                            </div>                           
                        </div>
                        <FormButton
                            handleSubmit={handleSubmit}
                            save={true}
                            Export={false}
                            Next={false}
                            nextButtonColor='btn-primary'
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div >
        </>
    )
}

export default AttendanceRequisition
